import { useSelector } from 'react-redux'
import { DYNAMIC_INDUSTRY_ROW_ID } from '../portfolioIndustry/constant'
import { selectCollapseInfoById } from '../portfolioIndustry/store/slice'

const withConditionRender =
  (Component) =>
  ({ rowId, selectRowData, isDynamic, ...other }) => {
    const rowData = useSelector(selectRowData(rowId))
    const collapseInfo = useSelector(selectCollapseInfoById(rowId))

    if (!rowData || !collapseInfo || collapseInfo.collapsedBy.length)
      return <></>

    if (isDynamic && !DYNAMIC_INDUSTRY_ROW_ID.includes(collapseInfo.level))
      return <></>

    return <Component rowId={rowId} {...other} />
  }

export default withConditionRender
